import { Column, CreateDateColumn, Entity, VersionColumn, PrimaryGeneratedColumn, UpdateDateColumn } from "typeorm";


@Entity("freebies_consumption")
export class FreebiesConsumptionEntity {
    @PrimaryGeneratedColumn('increment',{
        name:"freebies_consumption_id"
    }) 
    freebiesConsumptionId: number;

    @Column("int", {
        nullable:false,
        name:"employee_freebies_id"
    })
    employeeFreebiesId: number;

    @Column("varchar",{
        nullable:false,
        length: 20,
        name:"freebie_code"
    })
    freebieCode: string;

    @Column("varchar",{
        nullable:false,
        length: 25,
        name:"freebie_category"
    })
    freebieCategory: string;

    @Column("int",{
        nullable:false,
        name:"department_id"
    })
    departmentId: number;

    @Column("int",{
        nullable:false,
        name:"employee_id"
    })
    employeeId: number;

    @Column("varchar",{
        nullable:false,
        length: 20,
        name:"employee_code"
    })
    employeeCode: string;

    @Column("varchar",{
        nullable:false,
        name:"rf_code"
    })
    rfCode: string;

    @Column("int",{
        nullable:true,
        name:"visitor_id"
    })
    visitorId: number;

    @Column("smallint",{
        nullable:false,
        name:"year"
    })
    year: number;

    @Column("tinyint", {
        nullable: false,
        name:"month"
    })
    month: number;

    @Column("varchar", {
        nullable: true,
        name:"device_code"
    })
    deviceCode: string;

    @Column("decimal", {
        nullable: false,
        default:0,
        name:"unit_price"
    })
    unitPrice: number;

    @Column("boolean",{
        nullable:false,
        default:true,
        name: 'is_active'
    })
    isActive: boolean | null;
    
    @Column("varchar", {
        nullable: false,
        length: 40,
        name:'created_user' 
    })
    createdUser : string | null ;

    @CreateDateColumn({
        name:"created_at"
    })
    createdAt: Date;

    @Column("varchar",{
        nullable: true,
        length: 40,
        name:"updated_user"
    })
    updatedUser: string | null;

    @UpdateDateColumn({
        name:"updated_at"
    })
    updatedAt: Date;

    @VersionColumn({
        default: 1,
        name: 'version_flag'
    })
    versionFlag: number;

}